import { render, staticRenderFns } from "./SessionRecipient.vue?vue&type=template&id=13afe08d&scoped=true"
import script from "./SessionRecipient.vue?vue&type=script&lang=js"
export * from "./SessionRecipient.vue?vue&type=script&lang=js"
import style0 from "./SessionRecipient.vue?vue&type=style&index=0&id=13afe08d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13afe08d",
  null
  
)

export default component.exports